module.exports = __webpack_public_path__ + "img/icon_btc.f0377749.svg";